export default __webpack_public_path__ + "static/media/sugar_rises.ac661340.svg";